import {NonIndexRouteObject} from "react-router"
import {ErrorPage} from "../components/page";
import {navigationStore, vhsCustomerStore, vhsDetailStore, vhsListStore} from "../store";
import React from "react";
import {VhsApp} from "../components/app/VhsApp";


const vhs:NonIndexRouteObject[] = [
    {
        path: '/vhs',
        element: <VhsApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({params, request}) => {
            await vhsCustomerStore.init()
            const searchParams = new URL(request.url).searchParams

            vhsListStore.page = parseInt(searchParams.get("page") || "") || 1
            vhsListStore.size = parseInt(searchParams.get("size") || "") || 25
            vhsListStore.customerId = searchParams.get('customerId') || undefined
            vhsListStore.q = searchParams.get('q') || undefined

            vhsListStore.load().finally()
            navigationStore.setActivePath(request)

            return null
        }
    },
    {
        path: '/vhs/:customerId/:vin',
        element: <VhsApp mode={'detail'}/>,
        // errorElement: <Navigate to={`/vhs`} replace={true}/>,
        loader: async ({params, request}) => {
            const result = await vhsDetailStore.load(params.vin!!, params.customerId!!)
            if (!result) {
                throw Error
            }
            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    vhs
}
